import '../styles/score-cards.css';

import { selectIsAuthenticated } from '@/domain/auth/auth.selectors';
import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { selectImpactCalculateFestivalCo2ForProject } from '@/domain/impact-calculate-festival/impact-calculate-festival.selectors';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import {
  displayDecimal,
  displayTonsToKg,
} from '../../pdf/utils/display-scores.utils';
import ArrowIcon from '../assets/arrow.svg';
import CrossImg from '../assets/cross.svg';
import FairlyScorePillLogo from '../assets/fairly-score-pill-logo.svg';
import { MainScorePill } from '../components/MainScorePill';

export function ScoreCardsFestivalC2() {
  document.documentElement.classList.add('score-card');
  document.body.classList.add('score-card');

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const festival = useAppSelector(selectCurrentProjectFestival);
  const festivalId = festival?.id ?? 0;
  const impactCo2 = useAppSelector(
    selectImpactCalculateFestivalCo2ForProject(festivalId),
  ) satisfies CalculateFestivalCo2;

  if (!isAuthenticated) {
    return <h1>{translate('PdfExports.user-not-authentified')}</h1>;
  }

  if (!festival) {
    return <h1>{translate('PdfExports.festival-not-found')}</h1>;
  }

  return (
    <div id="card2" className="score-card-section">
      <div className="title">
        <img
          src={FairlyScorePillLogo}
          width="80"
          height="80"
          alt="Fairly logo"
        />
        <img src={CrossImg} width="30" height="30" />
        <h1>{festival.name}</h1>
      </div>
      <div className="scores">
        <div className="subtitle">
          <div className="score-row-left">
            <img src={ArrowIcon} width="40" height="40" />
            <span>{translate('Projects.co2')}</span>
          </div>
          <MainScorePill scoreLetter={impactCo2.scoreLetter} type="co2" />
        </div>
        <div className="score-row highlight">
          <span>{translate('PdfExports.total-emissions')}</span>
          <span>
            <span className="highlight">
              {displayTonsToKg(impactCo2.scoreKgeCO2)}
            </span>{' '}
            {translate('Projects.teCO2')}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Projects.emissions-by-participant')}</span>
          <span>
            {displayDecimal(impactCo2.kgeCO2ByParticipant)}{' '}
            {translate('Projects.kgeCO2')}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Projects.team')}</span>
          <span>
            {displayDecimal(impactCo2.sectors.team.score)}{' '}
            {translate('Projects.teCO2')}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Projects.artists')}</span>
          <span>
            {displayDecimal(impactCo2.sectors.artists.score)}{' '}
            {translate('Projects.teCO2')}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Projects.public')}</span>
          <span>
            {displayDecimal(impactCo2.sectors.public.score)}{' '}
            {translate('Projects.teCO2')}
          </span>
        </div>
        <div className="score-row">
          <span>{translate('Projects.site')}</span>
          <span>
            {displayDecimal(impactCo2.sectors.site.score)}{' '}
            {translate('Projects.teCO2')}
          </span>
        </div>
      </div>
    </div>
  );
}
